
import React from "react";
import { QuizQuestion as QuestionType, QuizOption } from "@/types";

interface QuizQuestionProps {
  question: QuestionType;
  selectedOption: string | null;
  onSelectOption: (optionId: string) => void;
  questionNumber: number;
  totalQuestions: number;
}

const QuizQuestion: React.FC<QuizQuestionProps> = ({
  question,
  selectedOption,
  onSelectOption,
  questionNumber,
  totalQuestions,
}) => {
  return (
    <div className="animate-fade-in-up">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-500">
            Question {questionNumber} of {totalQuestions}
          </span>
          <span className="text-sm font-medium text-white bg-techne-primaryPurple px-2 py-1 rounded-full">
            {Math.round((questionNumber / totalQuestions) * 100)}% Complete
          </span>
        </div>
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-techne-primaryPurple rounded-full transition-all duration-300"
            style={{ width: `${(questionNumber / totalQuestions) * 100}%` }}
          ></div>
        </div>
      </div>

      <h3 className="text-xl md:text-2xl font-semibold text-techne-primaryPurple mb-6">
        {question.text}
      </h3>

      <div className="space-y-3">
        {question.options.map((option: QuizOption) => (
          <button
            key={option.id}
            onClick={() => onSelectOption(option.id)}
            className={`w-full text-left p-4 border rounded-lg transition-all duration-300 ${
              selectedOption === option.id
                ? "border-techne-purple bg-techne-purple/10 text-techne-primaryPurple"
                : "border-gray-200 hover:border-techne-purple/50 hover:bg-gray-50"
            }`}
          >
            <div className="flex items-start gap-3">
              <div className={`w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0 mt-0.5 transition-all duration-300 ${
                selectedOption === option.id
                  ? "border-techne-purple bg-techne-purple"
                  : "border-gray-400"
              }`}>
                {selectedOption === option.id && (
                  <div className="w-2.5 h-2.5 rounded-full bg-white"></div>
                )}
              </div>
              <span className="text-gray-800">{option.text}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuizQuestion;
